import { render, staticRenderFns } from "./addSection.vue?vue&type=template&id=1d07b044"
import script from "./addSection.vue?vue&type=script&lang=js"
export * from "./addSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports